import { render, staticRenderFns } from "./terms-ja-JP.vue?vue&type=template&id=2c39221d"
import script from "./terms-ja-JP.vue?vue&type=script&lang=ts"
export * from "./terms-ja-JP.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports